import store from '@/store'
import ModuleBase from '../components/ModuleBase'
import ConstructionDashboard from '../views/Dashboard'

import ProjectBase from '@/modules/construction/components/ProjectBase'
import Overview from '@/modules/construction/views/Overview'
import ActionTracker from '@/modules/projects/views/ActionTracker'
// import Contacts from '@/modules/irrigation/views/Contacts' // this needs to move to projects folder when rebuilt
// import ProjectEstimates from '@/modules/irrigation/components/ProjectEstimates' // this needs to move to projects folder as well
import ProjectInvoices from '@/modules/projects/views/ProjectInvoices'
import ProjectWOs from '@/modules/projects/views/ProjectWOs'
import TimesheetDetails from '@/modules/projects/views/timesheetDetails/TimesheetDetails'
import ProjectCrewVisits from '@/modules/projects/views/ProjectCrewVisits'
import Reports from '@/modules/construction/components/reports/ConstructionReport'


const routes = [
  {
    path: '/construction/',
    component: ModuleBase,
    meta: { appKey: 'constructionprojects' },
    children: [
      {
        path: 'dashboard',
        component: ConstructionDashboard,
        name: 'ConstructionDashboard',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'details/:id/',
        component: ProjectBase,
        children: [
          {
            path: 'overview',
            component: Overview,
            name: 'ConstructionOverview'
          },
          {
            path: 'invoices',
            component: ProjectInvoices,
            name: 'ConstructionProjectInvoices'
          },
          {
            path: 'work-orders',
            component: ProjectWOs,
            name: 'ConstructionProjectWOs',
          },
          // {
          //   path: 'project-estimates',
          //   component: ProjectEstimates,
          //   name: 'ConstructionEstimates'
          // },
          {
            path: 'timesheet-details',
            component: TimesheetDetails,
            name: 'ConstructionTimesheetDetails',
          },
          {
            path: 'reports',
            component: Reports,
            name: 'ConstructionReports'
          },
          {
            path: 'action-tracker',
            component: ActionTracker,
            name: 'ConstructionActionTracker',
          },
          {
            path: 'crew-visits',
            component: ProjectCrewVisits,
            name: 'ConstructionCrewVisits',
          }
        ]
      },
    ]
  }
]

export default routes